// extracted by mini-css-extract-plugin
module.exports = {"reportingEvents":"AuditLogs_reportingEvents__zVOpH","table":"AuditLogs_table__2wwcX"};